export enum TransactionFilterType {
  Party = "Party",
  Amount = "Amount",
  ReconciliationStatus = "Status",
  Source = "Source",
  Date = "Date",
  Category = "Category",
  DimensionActivity = "DimensionActivity",
}

export enum CategoryManagerFilterType {
  Status = "Status",
  Type = "Type",
  Subtype = "Subtype",
  Integration = "Integration",
}
